import { Leaf, Droplet, Sun, Heart } from "lucide-react";

export default function About() {
  return (
    <div className="fade-up">
      <section className="bg-gradient-to-b from-[#F4EFE6]/60 to-[#FBF8F3] py-16 lg:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#9E3B21] mb-4">✦ Our Story</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1E1B18]">A jar of memories, delivered.</h1>
          <p className="mt-6 text-lg text-[#6E675F] leading-relaxed">
            Dadu&apos;s Achaar began with a single glass barni in a sunlit courtyard in Meerut — my grandfather&apos;s ritual of preserving each season&apos;s harvest in ancestral spice mixes and organic cold-pressed mustard oil.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="rounded-3xl overflow-hidden aspect-[4/5]">
            <img
              src="https://images.unsplash.com/photo-1599536884823-1bc4fb5f9dea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBwaWNrbGUlMjBqYXIlMjBzcGljZXMlMjBob21lbWFkZXxlbnwwfHx8fDE3ODgwMzE0NDZ8MA&ixlib=rb-4.1.0&q=85"
              alt="Kitchen craft"
              className="w-full h-full object-cover"
            />
          </div>
          <div>
            <h2 className="font-serif text-3xl lg:text-4xl font-semibold mb-6">Why Cold-Pressed Mustard Oil?</h2>
            <p className="text-[#4A423C] leading-relaxed mb-4">
              Kachi ghani mustard oil is extracted at low temperatures, preserving its pungent aroma, antioxidants, and natural preservative qualities. Unlike refined oils, it doesn't need chemicals to keep the pickle stable — the oil itself does the work.
            </p>
            <p className="text-[#4A423C] leading-relaxed">
              Every batch of Dadu's Achaar uses organic mustard seeds pressed within days of use. Nothing sits on a warehouse shelf for months.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#1E1B18] text-[#FBF8F3] py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#E5A83B] mb-4 text-center">✦ Our Craft</p>
          <h2 className="font-serif text-3xl sm:text-4xl font-semibold text-center mb-12">The Slow Way</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { icon: Leaf, title: "Sourced Organic", desc: "Certified organic produce from farms we visit personally." },
              { icon: Sun, title: "Sun-cured", desc: "Ingredients dried in direct sunlight, never in dehydrators." },
              { icon: Droplet, title: "Cold-pressed Oil", desc: "Kachi ghani mustard oil, aromatic and preservative-rich." },
              { icon: Heart, title: "Hand-jarred", desc: "Each barni is filled by hand, in a home kitchen, in small batches." },
            ].map((s) => (
              <div key={s.title} className="text-center">
                <div className="w-14 h-14 rounded-full bg-[#9E3B21]/25 flex items-center justify-center mx-auto mb-4">
                  <s.icon className="w-6 h-6 text-[#E5A83B]" />
                </div>
                <h3 className="font-serif text-lg font-semibold mb-2">{s.title}</h3>
                <p className="text-sm text-[#B8B0A6]">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
